import { BattlePlayerStatusType } from 'models/battles/BattlePlayerStatus';
import { Moment } from 'moment';
import React, { useEffect, useState } from 'react';
import Status from './Status';
import SelectStatus from './SelectStatus';
import BattlesService from '../../../../services/battles/BattlesService';
import useUpdateMyBattlePlayerStatus from '../../hook/api/useUpdateMyBattlePlayerStatus';
import { FormattedMessage } from 'react-intl';

export type CurrentStatusProps = {
	type: BattlePlayerStatusType;
	inactiveUntil?: Moment | null;
	onChange: () => void;
	'services.battlesService': BattlesService;
};

export const CurrentStatus = ({ type, inactiveUntil, onChange, ...props }: CurrentStatusProps) => {
	const { isSuccess, reset, mutate, isLoading } = useUpdateMyBattlePlayerStatus(props);
	const [isOpen, setIsOpen] = useState(false);

	useEffect(() => {
		if (isSuccess) {
			setIsOpen(false);
			onChange();
		}
	}, [isSuccess]);

	useEffect(() => {
		if (!isOpen) {
			reset();
		}
	}, [isOpen]);

	return (
		<div className="currentStatus position-relative">
			<div className="font-weight-bold">
				<Status type={type} onClick={() => setIsOpen(state => !state)}>
					<FormattedMessage
						id={`battles.status.current.${type}`}
						values={{
							time: !inactiveUntil ? '' : inactiveUntil.format('DD-MM-YYYY, HH:mm'),
						}}
					/>
				</Status>
			</div>
			{isOpen && (
				<SelectStatus
					isLoading={isLoading}
					onSelect={option => {
						mutate(option);
					}}
				/>
			)}
		</div>
	);
};

export default CurrentStatus;
